<template>
  <div class="historical">
    <h2 class="historical__title">{{ content.titles[geoArea] }}</h2>
    <div class="historical__content">
      <div class="historical__content__stacked">
        <TvaAreaChartStacked
          :data="getOilQualityTrend.dataset"
          :config="config"
        />
        <StackedAxisInfo :label="content.legend.text" />
        <BottomInfo :label="content.bottomInfo" />
      </div>
      <TopChart
        :label="content.label"
        :dataArray="getOilQualityPercentage"
        :historical="true"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TopChart from "./TopChart.vue";
import TvaAreaChartStacked from "../../charts/TvaAreaChartStacked.vue";
import BottomInfo from "./BottomInfo.vue";
import StackedAxisInfo from "./StackedAxisInfo.vue";

export default {
  name: "HistoricalTrend",
  props: {
    content: { type: Object },
  },
  data() {
    return {
      config: {
        globalUnitSymbol: "",
        globalDecimals: 2,
        globalLanguage: "en-US",
        globalFixedWidth: null,
        globalFixedHeight: null,
        globalMarginTop: 75,
        globalMarginRight: 172,
        globalMarginBottom: 0,
        globalMarginLeft: 0,
        gridXStrokeColor: "rgba(255, 255, 255, 0.1)",
        gridXStrokeWidth: 1,
        gridXStrokeDash: 0,
        gridYStrokeColor: "rgba(255, 255, 255, 0.1)",
        gridYStrokeWidth: 1,
        gridYBaselineStrokeWidth: 1.5,
        gridYStrokeDash: "0",
        xAxisHeight: 63.5,
        xAxisPosition: "bottom",
        xAxisTicksAmount: null,
        xAxisType: "string",
        xAxisTranslate: { x: 0, y: -37 },
        xAxisTickHeight: 63.5,
        xAxisTickStrokeColor: "rgba(255, 255, 255, 0.2)",
        xAxisTickStrokeWidth: 1,
        xAxisFontSize: 12,
        xAxisLabelXOffset: -5,
        xAxisLabelYOffset: 0,
        yAxisWidth: 173,
        yAxisPosition: "left",
        yAxisTicksAmount: 5,
        yAxisCurve: "curveCatmullRom",
        yAxisScale: "linear",
        yAxisType: "date",
        yAxisTickWidth: 173,
        yAxisTranslate: { x: -66, y: -5 },
        yAxisTickStrokeColor: "rgba(255, 255, 255, 0.2)",
        yAxisTickStrokeWidth: 1,
        yAxisFontSize: 12,
        yAxisLabelAnchor: "end",
        yAxisLabelXOffset: -5,
        yAxisLabelYOffset: 0,
        legendHeight: 0,
        legendPosition: "bottom",
        legendFontSize: 14,
        series: [
          {
            key: "Ultra Light",
            label: "Ultra Light",
          },
          {
            key: "Light & Sweet",
            label: "Light & Sweet",
          },
          {
            key: "Light & Medium Sour",
            label: "Light & Medium Sour",
          },
          {
            key: "Light & Sour",
            label: "Light & Sour",
          },
          {
            key: "Medium & Sweet",
            label: "Medium & Sweet",
          },
          {
            key: "Medium & Medium Sour",
            label: "Medium & Medium Sour",
          },
          {
            key: "Medium & Sour",
            label: "Medium & Sour",
          },
          {
            key: "Heavy & Sweet",
            label: "Heavy & Sweet",
          },
          {
            key: "Heavy & Medium Sour",
            label: "Heavy & Medium Sour",
          },
          {
            key: "Heavy & Sour",
            label: "Heavy & Sour",
          },
        ],
        xAxis: "year",
      },
    };
  },
  created() {
    this.setConfig();
  },
  watch: {
    getOilQualityTrend() {
      this.setConfig();
    },
  },
  methods: {
    setConfig() {
      this.config = { ...this.config, ...this.getOilQualityTrend.config };
    },
  },
  computed: {
    ...mapGetters({
      geoArea: "ui/geoArea",
      getOilQualityTrend: "data/getOilQualityTrend",
      getOilQualityPercentage: "data/getOilQualityPercentage",
    }),
  },
  components: { TopChart, TvaAreaChartStacked, BottomInfo, StackedAxisInfo },
};
</script>

<style lang="scss" scoped>
$height-title: toRem(42);

.historical {
  height: 100%;
  width: 100%;

  &__title {
    width: 100%;
    height: $height-title;
    border-bottom: toRem(1) solid $white-02;
    color: $ui-white;
    padding-left: toRem(60);
    @include title-H5;
    line-height: $height-title;
  }

  &__content {
    width: 100vw;
    height: auto;
    display: flex;

    &__stacked {
      width: calc(100vw - toRem(220));
      height: calc(
        100vh - $button-drill-height-open - $switch-drill-height -
          $switch-drill-height - $title-drill-height
      );
      position: relative;
    }
  }
}
</style>
